if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        document.addEventListener('DOMContentLoaded', () => {
          this.initForm();
        });
      }

      initForm() {
        this.form = this.querySelector('form');
        if (!this.form) {
          console.error('Form element not found');
          return;
        }

        console.log('Form element found');

        this.observeVariantSwatches();

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      observeVariantSwatches() {
        const observer = new MutationObserver(() => {
          const variantSwatches = this.form.querySelectorAll('label.v-swatch');
          if (variantSwatches.length > 0) {
            observer.disconnect();
            console.log('Variant swatches found:', variantSwatches);
            this.selectDesiredVariant(variantSwatches);
          }
        });

        observer.observe(this.form, {
          childList: true,
          subtree: true,
        });

        const variantSwatches = this.form.querySelectorAll('label.v-swatch');
        if (variantSwatches.length > 0) {
          console.log('Variant swatches found initially:', variantSwatches);
          this.selectDesiredVariant(variantSwatches);
        }
      }

      selectDesiredVariant(variantSwatches) {
        if (!variantSwatches || variantSwatches.length === 0) {
          console.error('Variant swatches not found during selectDesiredVariant');
          return;
        }

        const desiredVariantTitle = window.desiredVariantTitle; // Use the global variable set by Liquid
        console.log(`Attempting to select the variant with title: ${desiredVariantTitle}`);

        let desiredVariant = null;
        variantSwatches.forEach(swatch => {
          if (swatch.textContent.trim().includes(desiredVariantTitle)) { // Fixed the syntax error
            console.log('Desired variant found:', swatch);
            desiredVariant = swatch;
          }
        });

        if (desiredVariant) {
          desiredVariant.click();
          console.log(`Variant with title ${desiredVariantTitle} selected`);
        } else {
          console.error(`Variant with title ${desiredVariantTitle} not found`);
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const pairing = document.querySelector('[data-product-pairing]');
        const pairCheckbox = pairing && pairing.querySelector('[data-pair-checkbox]');
        const pairedVariantId = pairing && pairing.dataset.pairedVariantId;
        const addPair = pairCheckbox && pairCheckbox.checked && pairedVariantId;

        if (addPair) {
          const payload = {
            items: [
              { id: Number(formData.get('id')), quantity: Number(formData.get('quantity') || 1) },
              { id: Number(pairedVariantId), quantity: 1 }
            ]
          };
          if (this.cart) {
            payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
            payload.sections_url = window.location.pathname;
            this.cart.setActiveElement(document.activeElement);
          }
          config.headers['Content-Type'] = 'application/json';
          config.body = JSON.stringify(payload);
        } else {
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
document.addEventListener('DOMContentLoaded', function () {
  var desiredVariantTitle = window.desiredVariantTitle;

  if (desiredVariantTitle) {
    var variantSelect = document.querySelector('input[name="Framing Options"][value="' + desiredVariantTitle + '"]');
    
    if (variantSelect) {
      // Simulate a click to select the variant
      variantSelect.click();  

      // Update the URL without reloading the page
      var currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('variant', variantSelect.value);
      history.replaceState({}, '', currentUrl);

      // Update the swatch indicator and selected variant text
      var swatchElements = document.querySelectorAll('.variant-swatch');
      swatchElements.forEach(function(swatch) {
        if (swatch.querySelector('input').value === variantSelect.value) {
          swatch.classList.add('is-selected');
        } else {
          swatch.classList.remove('is-selected');
        }
      });

      var selectedVariantText = document.querySelector('.selected-variant-text');
      if (selectedVariantText) {
        selectedVariantText.textContent = desiredVariantTitle;
      }

      // Update hidden input for the form
      var hiddenInput = document.querySelector('input[name="id"]');
      if (hiddenInput) {
        hiddenInput.value = variantSelect.value;
      }
    }
  }
});
